import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBRow, MDBCol } from "mdbreact";
import content from "../Helpers/home-content-data";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol size="6" sm="4" key={key}>
          <MDBCard>
            <MDBCardBody style={{ textAlign: "justify" }}>
              <MDBCardTitle>{item.caption}</MDBCardTitle>

              {/* <MDBCardText style={{textAlign:"justify"}}> */}
              {item.description}
              {/* </MDBCardText> */}
              {/* <div style={{align:"right"}}><h6 >More</h6></div> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow>{cards}</MDBRow>
      </div>
    );
  }
}

export default HomeCardDeck;
